import { getAnnualReturnUsingRiskScore, VacationGoal } from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { getProgressUsingTargetAmount } from '../helpers';
import { BaseGoalConfig } from './types';

export const VACATION: BaseGoalConfig<VacationGoal> = {
    iconName: 'GoalVacation',
    color: colorsByGoalType['VACATION'].primary,
    defaultName: 'Vacation',
    getDescription: () => 'Start planning your next adventure.',
    group: 'INVEST',
    blogLink: null,
    getAnnualReturn: getAnnualReturnUsingRiskScore,
    getProgress: (config) => getProgressUsingTargetAmount(config),
};
